export enum Unit {
  cm = 'cm',
  kg = 'kg',
  g = 'g',
}
